// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SiteUnidades_GetResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** ResponseContract for GET /config/site_unidades/get/{id} — staff, i18n maps decoded. */
import type { SiteUnidades_StaffUnidadeRow } from './SiteUnidades_StaffUnidadeRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SiteUnidades_GetResponseDados {
unidade: SiteUnidades_StaffUnidadeRow
}

export type SiteUnidades_GetResponse = ApiResponse<SiteUnidades_GetResponseDados>;

registerResponseContract('SiteUnidades_GetResponse', {
  unidade: {
    type: 'object',
    required: false,
    fields: {
      id:                   { type: 'number',  required: true },
      franquia_id:          { type: 'number',  required: false },
      slug:                 { type: 'string',  required: true },
      nome:                 { type: 'object',  required: true },
      endereco:             { type: 'object',  required: true },
      whatsapp:             { type: 'string',  required: false },
      whatsapp_sem_tracos:  { type: 'string',  required: false },
      instagram:            { type: 'string',  required: false },
      facebook:             { type: 'string',  required: false },
      tiktok:               { type: 'string',  required: false },
      estado:               { type: 'string',  required: false },
      cidade:               { type: 'string',  required: false },
      pais:                 { type: 'string',  required: true },
      status:               { type: 'string',  required: true },
      latitude:             { type: 'number',  required: false },
      longitude:            { type: 'number',  required: false },
      coords_lock:          { type: 'boolean', required: true },
      imagem_url:           { type: 'string',  required: false },
      imagem_alt:           { type: 'string',  required: false },
      galeria: {
        type: 'array',
        required: false,
        items: {
          foto_url: { type: 'string',  required: true },
          foto_alt: { type: 'string',  required: false },
        },
      },
      horario_semana_abre:  { type: 'string',  required: false },
      horario_semana_fecha: { type: 'string',  required: false },
      horario_sabado_abre:  { type: 'string',  required: false },
      horario_sabado_fecha: { type: 'string',  required: false },
      arquivada_em:         { type: 'string',  required: false },
      created_at:           { type: 'string',  required: false },
      updated_at:           { type: 'string',  required: false },
      updated_by:           { type: 'string',  required: false },
      tracking: {
        type: 'object',
        required: false,
        fields: {
          google_ads_ids: { type: 'array',   required: false },
          meta_pixel:     { type: 'string',  required: false },
          gtm_extra:      { type: 'string',  required: false },
        },
      },
    },
  },
})
